<div
  class="info-table-item"
  [ngStyle]="{
    background:
      status === 'ACTIVE' &&
      data?.site?.siteVisitRequired &&
      !data?.proposal?.selectedSiteVisit &&
      !(
        data?.proposal?.siteVisit1 ||
        data?.proposal?.siteVisit2 ||
        data?.proposal?.siteVisit3
      )
        ? 'var(--background-5)'
        : 'transparent'
  }"
>
  <ng-container *ngIf="showStatus">
    <p class="status --invitation" *ngIf="status === 'INVITATION'">
      Invitation
    </p>
    <p class="status --proposal" *ngIf="status === 'SUBMITTED'">Submitted</p>
    <p class="status --offered" *ngIf="status === 'OFFERED'">Offered</p>
    <p class="status --bid-won" *ngIf="status === 'BID_WON'">Awarded</p>
    <p
      class="status --bid-lost"
      *ngIf="status === 'BID_LOST' || status === 'NO_RESPONSE'"
    >
      Not Awarded
    </p>
    <p class="status --bid-lost" *ngIf="status === 'CANCELLED'">Closed</p>
    <p
      class="status --active"
      *ngIf="
        [
          'ACTIVE',
          'IN_REVIEW',
          'REVIEW_PENDING',
          'REVISION_PENDING',
          'REVISION_REQUESTED'
        ].includes(status)
      "
    >
      Active
    </p>
    <p class="status --completed" *ngIf="status === 'COMPLETED'">Completed</p>
  </ng-container>
  <div class="address" *ngIf="showSite">
    <p class="address__site">#{{ site }}</p>
    <div class="address__address">
      <span
        class="material-icons address-pointer"
        [ngStyle]="
          data?.site?.specialSiteCondition
            ? { color: 'var(--error)', fontWeight: 'bold' }
            : { color: 'var(--text)' }
        "
        matTooltip="Click here for more info on Site Requirements."
        matTooltipPosition="above"
    matTooltipClass="site-req-tooltip"
        [matTooltipDisabled]="!data?.site?.specialSiteCondition"
        (click)="toggleMapModal('project-overview-proposal', id)"
        >info_outline</span
      >
      <div
        class="address-pointer"
        [routerLink]="['/', 'project-overview-proposal', id]"
      >
        <p>
          <span *ngIf="address.streetAddress"
            >{{ address.streetAddress }}<br /></span
          >{{ address.cityStateZip }}
        </p>
      </div>
    </div>
  </div>
  <p *ngIf="showAcreage" class="table-row-font">{{ acreage }}</p>
  <div
    *ngIf="showSiteType"
    class="address-pointer"
    [routerLink]="['/', 'project-overview-proposal', id]"
  >
    <div class="service-type">
      <p>{{ siteSubType ? siteType + " - " + siteSubType : siteType }}</p>
    </div>
  </div>
  <p *ngIf="showLandUse" class="table-row-font">
    {{ landUse || "Not Provided" }}
  </p>
  <div
    *ngIf="showSiteRequirements"
    class="site-req"
    [ngClass]="{ 'site-req--active': data?.site?.specialSiteCondition || (data?.site?.tableAChanges && (data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)) }"
    [matTooltip]="getFullSiteReqTooltip()"
    [matTooltipDisabled]="!data?.site?.specialSiteCondition && !(data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)"
    matTooltipPosition="above"
    matTooltipClass="site-req-tooltip"
  >
    <ng-container *ngIf="data?.site?.tableAChanges && (data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)">
      <div class="site-req__table-a">
        <p class="table-row-font"><strong>Table A:</strong></p>
        <p *ngIf="data?.site?.tableAChanges?.itemsAdded" class="table-row-font site-req__added">+ {{ data.site.tableAChanges.itemsAdded }}</p>
        <p *ngIf="data?.site?.tableAChanges?.itemsRemoved" class="table-row-font site-req__removed">− {{ data.site.tableAChanges.itemsRemoved }}</p>
      </div>
      <hr *ngIf="data?.site?.specialSiteCondition" class="site-req__divider" />
    </ng-container>
    <p *ngIf="data?.site?.specialSiteCondition" class="table-row-font">{{
      data?.site?.specialSiteCondition?.length > 100
        ? (data?.site?.specialSiteCondition | slice:0:100) + '...'
        : data?.site?.specialSiteCondition
    }}</p>
  </div>

  <div
    *ngIf="
      status === 'BID_LOST' ||
        status === 'NO_RESPONSE' ||
        status === 'CANCELLED';
      else notBidLost
    "
  >
    <div class="info-table-item__docs-info">
      <span class="info-table-item__icon-text" *ngIf="!isAlta">
        <div class="documents" (click)="toggleOpenExpensesModal()">
          <span class="material-icons">wallet</span>
        </div>
        <span class="documents-label">Expenses</span>
      </span>
      <span class="info-table-item__icon-text">
        <div class="documents-disabled">
          <span class="material-icons">upload</span>
          <div *ngIf="documents?.length > 0" class="documents__number">
            {{ documents?.length }}
          </div>
        </div>
        <span class="documents-label-disabled">Documents</span>
      </span>
      <span class="info-table-item__icon-text">
        <div class="documents-disabled">
          <span class="material-icons">notes</span>
        </div>
        <span class="documents-label-disabled">Notes</span>
      </span>
    </div>
  </div>
  <ng-template #notBidLost>
    <div class="info-table-item__docs-info">
      <span class="info-table-item__icon-text" *ngIf="!isAlta">
        <div class="documents" (click)="toggleOpenExpensesModal()">
          <span class="material-icons">wallet</span>
        </div>
        <span class="documents-label">Expenses</span>
      </span>
      <span class="info-table-item__icon-text">
        <div class="documents" (click)="toggleOpenDocumentsModal()">
          <span class="material-icons">upload</span>
          <div *ngIf="documents?.length > 0" class="documents__number">
            {{ documents?.length }}
          </div>
        </div>
        <span class="documents-label">Documents</span>
      </span>
      <span class="info-table-item__icon-text">
        <div class="documents" (click)="toggleNotesModal()">
          <span class="material-icons">notes</span>
        </div>
        <span class="documents-label">Notes</span>
      </span>
    </div>
  </ng-template>

  <ng-container *ngIf="showActions">
    <div
      *ngIf="
        status === 'INVITATION' ||
        status === 'SUBMITTED' ||
        status === 'BID_WON' ||
        status === 'BID_LOST' ||
        status === 'NO_RESPONSE' ||
        status === 'OFFERED' ||
        status === 'COMPLETED' ||
        status === 'CANCELLED'
      "
    >
      <div
        *ngIf="
          status === 'SUBMITTED' ||
          status === 'BID_WON' ||
          status === 'BID_LOST' ||
          status === 'NO_RESPONSE' ||
          status === 'OFFERED' ||
          status === 'COMPLETED' ||
          status === 'CANCELLED'
        "
        class="proposals-actions"
      >
        <div class="turn-time" *ngIf="!isDesiredByDate">
          <p>
            <span *ngIf="isFixedPrice; else tat">Due Date</span>
            <ng-template #tat>Turn Time</ng-template>
          </p>
          <span *ngIf="isFixedPrice; else tt"
            ><p>
              {{
                data.proposal.proposedDeliverDate | date : "MM/dd/yyyy" : locale
              }}
            </p></span
          >
          <ng-template #tt
            ><p>{{ turnTime }} Days</p></ng-template
          >
        </div>
        <div *ngIf="isDesiredByDate" class="table-row-font">
          <p class="info-table-actions-edit__item__label">Due Date</p>
          <p>
            {{ desiredByDate | date : "MM/dd/yyyy" : locale }}
          </p>
        </div>
        <div class="bid-amount">
          <p *ngIf="!isFixedPrice; else offer">Bid Amount</p>
          <ng-template #offer><p>Offer Amount</p></ng-template>
          <p>{{ bidAmount | currency : "USD" : "symbol" : "1.0-0" }}</p>
        </div>
      </div>
      <div
        *ngIf="
          status === 'INVITATION'
        "
        class="info-table-actions-edit"
      >
        <div class="info-table-actions-edit__item" *ngIf="!isDesiredByDate">
          <p class="info-table-actions-edit__item__label">Turn Time</p>
          <div class="info-table-actions-edit__item__input">
            <input
              id="turnTime{{ rowIndex }}"
              type="number"
              placeholder="Business Days"
              [(ngModel)]="turnTime"
              (blur)="saveTurnTime()"
            />
          </div>
        </div>
        <div *ngIf="isDesiredByDate" class="table-row-font">
          <p class="info-table-actions-edit__item__label">Due Date</p>
          <p>
            {{ desiredByDate | date : "MM/dd/yyyy" : locale }}
          </p>
        </div>
        <div
          class="info-table-actions-edit__item"
          *ngIf="
            status === 'INVITATION'
          "
        >
          <p
            class="info-table-actions-edit__item__label"
            *ngIf="!isFixedPrice; else offer"
          >
            Bid Amount
          </p>
          <ng-template #offer
            ><p class="info-table-actions-edit__item__label">
              Offer Amount
            </p></ng-template
          >
          <div class="info-table-actions-edit__item__input">
            <input
              id="bidAmount{{ rowIndex }}"
              type="number"
              placeholder="$"
              value=""
              [(ngModel)]="bidAmount"
              (blur)="saveBidAmount()"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="info-table-review submit-review-align"
      *ngIf="
        status === 'ACTIVE' ||
        status === 'REVISION_REQUESTED' ||
        status === 'REVIEW_PENDING' ||
        status === 'REVISION_PENDING'
      "
    >
      <button
        class="site-visit-button"
        [ngStyle]="{ background: 'var(--error)', color: 'white' }"
        *ngIf="
          status === 'ACTIVE' &&
          data?.site?.siteVisitRequired &&
          !data?.proposal?.selectedSiteVisit &&
          !(
            data?.proposal?.siteVisit1 ||
            data?.proposal?.siteVisit2 ||
            data?.proposal?.siteVisit3
          )
        "
        (click)="toggleSiteVistModal()"
      >
        Schedule Site Visit
      </button>
      <button
        class="submit-review-revision-button"
        [disabled]="!showReviewSubmission"
        *ngIf="
          status === 'ACTIVE' &&
          (!data?.site?.siteVisitRequired ||
            (data?.site?.siteVisitRequired &&
              (data?.proposal?.selectedSiteVisit ||
                data?.proposal?.siteVisit1 ||
                data?.proposal?.siteVisit2 ||
                data?.proposal?.siteVisit3)))
        "
        [ngStyle]="{
          background: showReviewSubmission ? 'var(--text)' : '#cfcfcf',
          color: showReviewSubmission ? '#ffffff' : 'var(--text)'
        }"
        (click)="submitProposal()"
      >
        {{
          !showReviewSubmission
            ? "Deliverable Document Required"
            : "Submit Review"
        }}
      </button>
      <button
        class="submit-review-revision-button"
        *ngIf="status === 'REVISION_REQUESTED'"
        [disabled]="!showRevisionSubmission"
        [ngStyle]="{
          background: showRevisionSubmission ? 'var(--text)' : '#cfcfcf',
          color: showRevisionSubmission ? '#ffffff' : 'var(--text)'
        }"
        (click)="submitProposal()"
      >
        {{
          !showRevisionSubmission
            ? "Revision Document Required"
            : "Submit Revision"
        }}
      </button>
      <p class="pending-review-label" *ngIf="status === 'REVIEW_PENDING'">
        Review Pending
      </p>
      <p class="pending-review-label" *ngIf="status === 'REVISION_PENDING'">
        Revision Pending
      </p>
      <div class="proposals-actions">
        <span class="price">
          Fee:
          {{ bidAmount | currency : "USD" : "symbol" : "1.0-0" }}
        </span>
      </div>
      <div class="proposals-actions">
        <span class="active-delivery-date">
          Due Date:
          {{
            (isDesiredByDate
              ? desiredByDate
              : data.proposal.proposedDeliverDate
            ) | date : "MM/dd/yyyy" : locale
          }}
        </span>
      </div>
      <div *ngIf="data.proposal.selectedSiteVisit" class="proposals-actions">
        <span class="active-delivery-date">
          Site Visit Date:
          {{
            (data.proposal.selectedSiteVisit?.date
              | date : "MM/dd/yyyy" : "UTC") +
              " (" +
              data.proposal.selectedSiteVisit?.slot +
              ")"
          }}
        </span>
      </div>
    </div>
  </ng-container>
  <div
    *ngIf="
      status === 'INVITATION' ||
      status === 'OFFERED' ||
      (status === 'SUBMITTED' && isFixedPrice)
    "
    class="info-table-button"
    (click)="toggleDeclineModal()"
  >
    <span class="material-icons decline-icon">close</span>
    <p>Decline</p>
  </div>
  <div
    class="info-table-button address-pointer"
    [routerLink]="['/', 'project-overview-proposal', id]"
  >
    <span class="material-icons">visibility</span>
    <p>View</p>
  </div>

  <mapmodal-dialog
    [active]="mapActive"
    [siteType]="selectedSiteType"
    [siteId]="selectedSiteId"
    [data]="data"
    [address]="address"
    (modalClosed)="toggleMapModal('project-overview-proposal', id)"
    [ngClass]="{ 'mapmodal-dialog--active': mapActive }"
  ></mapmodal-dialog>
</div>

<decline-dialog
  [siteId]="data.site.id"
  [active]="isDeclineActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  [isFixedPrice]="isFixedPrice"
  (decline)="declineProposal($event)"
  (modalClosed)="toggleDeclineModal()"
  [ngClass]="{ 'documents-dialog--active': isDeclineActive }"
></decline-dialog>

<submit-for-review-dialog
  [active]="submitForReviewActive"
  [documents]="documents"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  [status]="data.proposal.status"
  [siteId]="data.site.id"
  [isAlta]="isAlta"
  (modalClosed)="toggleSubmitForReviewModal()"
  (submitReview)="submitReview()"
  (submitRevision)="submitRevision()"
  [ngClass]="{ 'documents-dialog--active': submitForReviewActive }"
></submit-for-review-dialog>

<documents-dialog
  [data]="data"
  [active]="documentsActive"
  [documents]="documents"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleCloseDocumentsModal()"
  (update)="updateDocuments($event)"
  [ngClass]="{ 'documents-dialog--active': documentsActive }"
></documents-dialog>

<notes-dialog
  [active]="notesActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleNotesModal()"
  [ngClass]="{ 'documents-dialog--active': notesActive }"
  [bidNotes]="bidNotes"
  [data]="data"
  (saveBidNotes)="saveBidNote($event)"
></notes-dialog>

<comments-dialog
  [active]="commentsActive"
  [documents]="documents"
  [siteType]="siteType"
  [address]="address"
  (modalClosed)="toggleCommentsModal()"
  [ngClass]="{ 'documents-dialog--active': commentsActive }"
></comments-dialog>

<site-visit-dialog
  [active]="siteVisitActive"
  [address]="address"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [siteDetail]="data"
  [proposal]="data?.proposal"
  (modalClosed)="toggleSiteVistModal()"
  (updateSiteVisitSiteDetail)="submitSiteVisit($event)"
/>

<expenses-dialog
  [data]="data"
  [active]="expensesActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleCloseExpensesModal()"
  (saveExpenses)="saveExpense($event)"
  [ngClass]="{ 'documents-dialog--active': expensesActive }"
/>
